import { render } from "./drop_container.vue?vue&type=template&id=063f59f4&ts=true"
import script from "./drop_container.vue?vue&type=script&lang=ts"
export * from "./drop_container.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__